const ja = {
  full_name: "氏名",
  address: "住所",
  email_address: "メールアドレス",
  please_check_i_agree: "「同意する」にチェックをつけてください！",
  please_enter_your_email_address_correctly: "メールアドレスを正しく入力して下さい",
  please_enter_your_email_address: "メールアドレスを入力して下さい",
  please_register_the_delivery_address_information_of_the_cash_voucher: "金券の送付先情報を登録してください。",
  after_the_lottery_we_will_send_the_coupon_to_your_registered_address: "抽選の上、ご登録の住所に金券を送付させて頂きます",
  notice_and_consent_statement_regarding_our_handling_of_personal_information: "弊社個人情報取扱における告知・同意文",
  please_agree_to_and_proceed_to_registration: "に同意の上、ご登録へとお進みください。",
  thank_you_for_registering: "ご登録ありがとうございます。",
  winners_will_be_selected_by_a_strict_lottery_and_will_be_notified_by_mail: "厳正な抽選の上、当選の発表は発送をもってかえさせていただきます"
}
export default ja;